import { render, staticRenderFns } from "./EquipmentHeader.vue?vue&type=template&id=4b935f60&scoped=true"
import script from "./EquipmentHeader.vue?vue&type=script&lang=js"
export * from "./EquipmentHeader.vue?vue&type=script&lang=js"
import style0 from "./EquipmentHeader.vue?vue&type=style&index=0&id=4b935f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b935f60",
  null
  
)

export default component.exports